import {Map} from 'immutable';
import * as actionTypes from '../../actions/types';

const initialState = new Map({
  returnPath: ''
});

export default function (state = initialState, action) {
  switch (action.type) {
    case actionTypes.SET_RETURN_PATH:
      return state.set('returnPath', action.payload);

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./app/features/authentication/reducers/pages/verifyUser.js